import * as React from "react";

const SvgFileJpg = props => {
  const { size, fill } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={fill}
      {...props}
    >
      <path d="M17.5 6h3.9a.25.25 0 00.17-.43L16.43.43A.25.25 0 0016 .6v3.9A1.5 1.5 0 0017.5 6zM12 13.12h-.62a.26.26 0 00-.26.26v1.24a.26.26 0 00.26.26H12a.88.88 0 000-1.76z" />
      <path d="M21.75 7H17.5A2.5 2.5 0 0115 4.5V.25a.25.25 0 00-.25-.25H4a2 2 0 00-2 2v20a2 2 0 002 2h16a2 2 0 002-2V7.25a.25.25 0 00-.25-.25zM9.12 17a2.12 2.12 0 11-4.24 0 .62.62 0 111.24 0 .88.88 0 101.76 0v-4.5a.62.62 0 011.24 0zm2.75-.88h-.49a.26.26 0 00-.26.26v2.12a.62.62 0 11-1.24 0v-6a.61.61 0 01.62-.62H12a2.12 2.12 0 012.11 2.34 2.2 2.2 0 01-2.24 1.9zm7.25-1.62a.62.62 0 11-1.24 0V14a.88.88 0 00-1.76 0v3a.88.88 0 001.65.42c.05-.09.12-.3-.09-.3h-.18a.62.62 0 110-1.24h1a.62.62 0 01.62.62v.5a2.12 2.12 0 01-4.24 0v-3a2.12 2.12 0 014.24 0z" />
    </svg>
  );
};

export default SvgFileJpg;
